import {NODE_FETCH} from "../node/nodeActions";
import {CATALOG_CLEAR, CATALOG_FETCH} from "./catalogActions";
import {getActionExtras} from "../../middlewares/action-decorator/middlewareFactory";
import {REQUEST_ERROR, REQUEST_INIT, REQUEST_SUCCESS} from "../../middlewares/request/requestActions";
import {getCatalog} from "../../utils/catalog";

const catalogReducer = (state = null, action) => {
  switch (action.type) {
    case CATALOG_CLEAR: {
      return null;
    }
    case REQUEST_INIT: {
      switch (action.payload.label) {
        case NODE_FETCH:
        case CATALOG_FETCH: {
          return null;
        }
        default:
          return state;
      }
    }
    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case CATALOG_FETCH: {
          const {t} = getActionExtras(action);

          return {
            nodeId: action.payload.extra.nodeId,
            ...getCatalog(action.payload.response, false, t)
          };
        }
        default:
          return state;
      }
    }
    case REQUEST_ERROR: {
      switch (action.payload.label) {
        case CATALOG_FETCH: {
          const {t} = getActionExtras(action);

          return {
            nodeId: action.payload.extra.nodeId,
            ...getCatalog({}, false, t)
          };
        }
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default catalogReducer;
